import { render, staticRenderFns } from "./BaseDeleteButton.vue?vue&type=template&id=add49902&scoped=true&"
import script from "./BaseDeleteButton.vue?vue&type=script&lang=js&"
export * from "./BaseDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add49902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
